export default __webpack_public_path__ + "static/presentation-985c82c86bb6390c114411a54176b393.png";